import gql from 'graphql-tag';

// Base fragment for Estimate
export const ESTIMATE_BASE_FRAGMENT = gql`
  fragment EstimateBaseFragment on Estimate {
    id
    job_id
    account_id
    chat_id
    crew_id
    checklist_id
    client_account_id
    property_id
    isArchived
    estimatedHours
    discount
    depositRequired
    total
    taxRate
    taxRateName
    taxableTotal
    subtotal
    name
    tax
    status
    isViewedByClient
    isViewedByClientTimestamp
    commentToClient
    clientApprovedSignatureImageUrl
    clientApprovedSignatureImageBase64
    clientApprovedSignatureTimestamp
    validUntil
    createdAt
    updatedAt
    validUntil
  }
`;

// Base fragment for Invoice (for future use)
export const INVOICE_BASE_FRAGMENT = gql`
  fragment InvoiceBaseFragment on Invoice {
    id
    job_id
    client_account_id
    chat_id
    account_id
    taxRate
    discount
    depositRequired
    total
    subtotal
    totalPaid
    balanceDue
    tax
    taxRateName
    invoiceNumber
    name
    status
    issueDate
    dueDateType
    dueDate
    isPastDue
    clientMessage
    createdAt
    updatedAt
  }
`;

// Base fragment for Job (for future use)
export const JOB_BASE_FRAGMENT = gql`
  fragment JobBaseFragment on Job {
    id
    name
    status
    description
    scheduledDate
    estimatedHours
    actualHours
    total
    subtotal
    tax
    discount
    depositRequired
    createdAt
    updatedAt
  }
`;
